import React from 'react';
import { IconButton } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import type { LayerTypes } from './globals';
import { SYS_COLOR_FOREGROUND_NEUTRAL_800_LIGHT } from '@oneaudi/unified-web-common';

const CloseButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: ${process.env.IS_LEGACY === 'true'
    ? SYS_COLOR_FOREGROUND_NEUTRAL_800_LIGHT
    : 'transparent'};
  z-index: 100;
`;

type Icon = {
  icon: string;
};

interface IClose {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClose: (e: any) => void;
  type?: LayerTypes;
  icon?: Icon;
}

const DefaultCloseButton: React.FC<IClose> = (props) => {
  const { onClose } = props;

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onClose(e);
  };

  return (
    <IconButton
      aria-label="Close layer"
      data-testid="one-layer-close"
      onClick={handleClick}
      title="closebutton"
      rel="noopener"
      //@ts-expect-error alpha contains xs size
      size={process.env.IS_LEGACY ? 'md' : 'xs'}
      variant="tertiary"
      icon="cancel"
    />
  );
};

const Close: React.FC<IClose> = (props) => {
  return (
    <CloseButtonWrapper>
      <DefaultCloseButton {...props} />
    </CloseButtonWrapper>
  );
};

export default Close;
